import { z } from "zod";

import type { t as translate } from "@/lib/i18n";

type T = typeof translate;

/**
 * A new lander (board LanderCreate) and a lander's settings (board
 * LanderSettings). Type and risk are the proto's enum numbers; the address of
 * a page brought «По ссылке» must be one a browser would open. Built with the
 * screen's `t`, so the messages follow the interface language.
 */
const nameOf = (t: T) => z.string().trim().min(1, t("landers.err.name")).max(200, t("landers.err.nameLong"));

export const landerCreateSchema = (t: T) =>
  z
    .object({
      source: z.enum(["zip", "link", "studio"]),
      name: nameOf(t),
      type: z.number().int().min(1).max(5),
      language: z.string(),
      countries: z.array(z.string().length(2)),
      risk: z.number().int().min(1).max(3),
      url: z.string().trim(),
    })
    .superRefine((v, ctx) => {
      if (v.source !== "link") return;
      let ok = false;
      try {
        const u = new URL(v.url);
        ok = u.protocol === "https:" || u.protocol === "http:";
      } catch {
        ok = false;
      }
      if (!ok) ctx.addIssue({ code: "custom", path: ["url"], message: t("landers.err.url") });
    });

export type LanderCreateValues = z.infer<ReturnType<typeof landerCreateSchema>>;

export const landerSettingsSchema = (t: T) =>
  z.object({
    name: nameOf(t),
    type: z.number().int().min(1).max(5),
    isDefault: z.boolean(),
    risk: z.number().int().min(1).max(3),
    countries: z.array(z.string().length(2)),
    language: z.string(),
    ctas: z.number().int().min(1, t("landers.err.ctas")).max(20, t("landers.err.ctas")),
    domainId: z.string(),
    notes: z.string().max(4000),
  });

export type LanderSettingsValues = z.infer<ReturnType<typeof landerSettingsSchema>>;
